export const PersistentMenuTemplate = (length) => {
    return {
        options: new Array(length).fill({}),
    };
};
export const MaxFirstLevelItems = 3;
